
import {
  inrCountryValidator,
  emptyValidator,
  emailValidator,
  validZipCode,
  addEmailValidator
} from '../../../utils/validator';
import {translateMixins} from '../../../plugins/i18n';
export const countriesWithState = ['US', 'CA', 'IN'];
export default {
  mixins: [translateMixins],
  data() {
    const checkEduAgeGroupRequired = (rule, value, callback) => {
      this.$nextTick(() => {
        if (this.form.isForEdu && this.form.coppa.length === 0) {
          callback(new Error(this.__$t("billing.addr.for_edu.required_tip")))
        } else {
          callback();
        }
      })
    };
    return {
      rules: {
        firstName: [
          {
            validator: emptyValidator,
            message: this.__$t('billing.error.empty_valid', [this.__$t('billing.first_name')]),
            trigger: ['blur', 'change'],
            required: true
          }
        ],
        lastName: [
          {
            validator: emptyValidator,
            message: this.__$t('billing.error.empty_valid', [this.__$t('billing.last_name')]),
            trigger: ['blur', 'change'],
            required: true
          }
        ],
        email: [
          {
            validator: emptyValidator,
            message: this.__$t('billing.error.empty_valid', [this.__$t('billing.email_address')]),
            trigger: ['blur', 'change'],
            required: true
          },
          {
            validator: async (rule, value, callback) => {
              const is = emailValidator(value);
              if (!is) return callback(new Error('Email Address is incorrect'));
              callback();
            },
            trigger: 'blur',
          },
        ],
        additionalEmail: [
          {
            validator: async (rule, value, callback) => {
              if (!value || value.trim() === '') {
                callback();
              } else {
                const is = addEmailValidator(value);
                if (!is) return callback(new Error('Email Address is incorrect'));
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
        address1: [
          {
            validator: emptyValidator,
            message: this.__$t("billing.error.empty_valid", [
              this.__$t("billing.address.text")
            ]),
            trigger: "blur",
            required: true,
          },
        ],
        employeeCount: [{
          validator: emptyValidator,
          trigger: "blur" ,
          message: this.__$t("billing.error.empty_valid", [
            this.__$t("billing.addr.business_size")
          ]),
          required: true,
        }],
        businessType: [{
          validator: emptyValidator,
          trigger: "blur" ,
          message: this.__$t("billing.error.empty_valid", [
            this.__$t("billing.export_control.biz_org_type")
          ]),
          required: true,
        }],
        otherBusinessType: [{
          validator: emptyValidator,
          trigger: "blur" ,
          message: this.__$t("billing.error.empty_valid", [
            this.__$t("billing.export_control.input_placeholder")
          ]),
          required: true,
        }],
        city: [
          {
            validator: emptyValidator,
            message: this.__$t("billing.error.empty_valid", [
              this.__$t("billing.city")
            ]),
            trigger: ["blur","change"],
            required: true,
          }
        ],
        state: [
          {
            validator:  emptyValidator,
            message: this.__$t("billing.error.empty_valid", [
              this.__$t("billing.state")
            ]),
            trigger: ["blur","change"],
            required: true,
          }
        ],
        country: [
          {
            validator: emptyValidator,
            message: this.__$t("billing.error.empty_valid", [
              this.__$t("billing.country_region")
            ]),
            trigger: ["blur","change"],
            required: true,
          }
        ],
        // phone is optional in new payment
       /* phone: [
          {
            validator: emptyValidator,
            message: this.__$t("billing.error.empty_valid", [
              this.__$t("billing.address.phone")
            ]),
            trigger: ["blur","change"]
          },
        ],*/
        zip: [
          {
            validator: emptyValidator,
            message: this.__$t("billing.error.empty_valid", [
              this.__$t("billing.zip_postal")
            ]),
            trigger: "blur",
            required: true,
          },
          {
            validator: (rule, value, callback) => {
              const errorI18nKey = validZipCode(this.form);
              if (errorI18nKey) {
                callback(new Error(this.__$t(errorI18nKey)));
              } else {
                callback();
              }
            }
          }
        ],
        accountHq: [
          {
            validator: emptyValidator,
            message: this.__$t("billing.error.empty_valid", [
              this.__$t("billing.addr.hq")
            ]),
            trigger: "blur",
            required: true,
          }
        ],
        companyName:[{
            validator: emptyValidator,
            message: this.__$t("billing.error.empty_valid", [
              this.__$t("billing.company_organization_legal")
            ]),
            trigger: "blur",
            required: true,
        }],
        orgName: [
          {
            validator: emptyValidator,
            message: this.__$t("billing.error.empty_valid", [
              this.__$t("billing.addr.org_name")
            ]),
            trigger: "blur",
          }
        ],
        orgCount: [
          {
            validator: emptyValidator,
            message: this.__$t("billing.error.empty_valid", [
              this.__$t("billing.addr.org_size")
            ]),
            trigger: "blur",
            required: true,
          }
        ],
        coppa: [
          { validator: checkEduAgeGroupRequired, trigger: "change" ,required: true}
        ],
        useCase: [{
          validator: emptyValidator,
          trigger: "blur" ,
          message: this.__$t("billing.error.empty_valid", [
            this.__$t("billing.video_sdk.use_case")
          ]),
          required: true,
        }],
        otherUseCase: [{
          validator: emptyValidator,
          trigger: "blur" ,
          message: this.__$t("billing.error.empty_valid", [
            this.__$t("billing.video_sdk.use_case_other")
          ]),
          required: true,
        }],
      }
    };
  },
  methods: {
    addInrCountryValidator() {
      this.rules.country.push(
        {
          validator: inrCountryValidator,
          trigger: ['blur', 'change'],
        },
      );
    },
  },
  mounted() {
  },
};
